module.exports = __webpack_public_path__ + "img/sankaku_25_red.01f80b4b.png";